import { FC } from 'react';
import styles from './styles.module.scss';
import { Typography } from '@sravni/react-design-system';

interface Props {
    isHidden?: boolean;
    currentField: number;
    fields: number;
}

const { Heading } = Typography;

export const FieldsCounter: FC<Props> = (props) => {
    const { isHidden, fields, currentField } = props;

    if (isHidden) {
        return null;
    }

    return (
        <div className={styles['fields-counter']}>
            <Heading level={4} className={styles['fields-counter__text']}>
                {currentField} <span className={styles['text-divider']}>/</span> {fields}
            </Heading>
        </div>
    );
};
